/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The CheckinstokengoalsAnswers model module.
 * @module model/CheckinstokengoalsAnswers
 * @version v0.3
 */
export default class CheckinstokengoalsAnswers {
  /**
   * Constructs a new <code>CheckinstokengoalsAnswers</code>.
   * @alias module:model/CheckinstokengoalsAnswers
   * @class
   * @param goalId {String}
   * @param completed {Boolean}
   */
  constructor(goalId, completed) {
    this.goalId = goalId;
    this.completed = completed;
  }

  /**
   * Constructs a <code>CheckinstokengoalsAnswers</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CheckinstokengoalsAnswers} obj Optional instance to populate.
   * @return {module:model/CheckinstokengoalsAnswers} The populated <code>CheckinstokengoalsAnswers</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CheckinstokengoalsAnswers();
      if (data.hasOwnProperty('goal_id'))
        obj.goalId = ApiClient.convertToType(data['goal_id'], 'String');
      if (data.hasOwnProperty('completed'))
        obj.completed = ApiClient.convertToType(data['completed'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} goalId
 */
CheckinstokengoalsAnswers.prototype.goalId = undefined;

/**
 * @member {Boolean} completed
 */
CheckinstokengoalsAnswers.prototype.completed = undefined;
